/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Req_2Inputs */

const en_pc_dl_req_2 = /** @type {(inputs: Pc_Dl_Req_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linux with glibc 2.35 or newer (Ubuntu 22.04+, Debian 12+, Fedora 36+, RHEL 10). RISC-V builds need glibc 2.39 or newer (Ubuntu 24.04+, Debian 13+).`)
};

const zh_pc_dl_req_2 = /** @type {(inputs: Pc_Dl_Req_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linux 需要 glibc 2.35 或更高版本（Ubuntu 22.04+、Debian 12+、Fedora 36+、RHEL 10）。RISC-V 版本需要 glibc 2.39 或更高版本（Ubuntu 24.04+、Debian 13+）。`)
};

/**
* | output |
* | --- |
* | "Linux with glibc 2.35 or newer (Ubuntu 22.04+, Debian 12+, Fedora 36+, RHEL 10). RISC-V builds need glibc 2.39 or newer (Ubuntu 24.04+, Debian 13+)." |
*
* @param {Pc_Dl_Req_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_req_2 = /** @type {((inputs?: Pc_Dl_Req_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Req_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_req_2(inputs)
	return zh_pc_dl_req_2(inputs)
});
export { pc_dl_req_2 as "pc.dl.req.2" }